export const mergeAgreementsWithPrices = (agreementsResult, priceResult) => {
    const priceById = new Map(priceResult.map((price) => [price.agreementId, price]));
    return agreementsResult.map((agreement) => {
        var _a;
        const price = priceById.get(agreement.agreementId);
        const agreementPrice = (_a = price === null || price === void 0 ? void 0 : price.agreementPrice) !== null && _a !== void 0 ? _a : null;
        return {
            agreementId: agreement.agreementId,
            productNames: agreement.productNames,
            originalPrice: agreementPrice,
            currentPrice: agreementPrice,
        };
    });
};
